module.exports = __webpack_public_path__ + "static/media/pdf.0f993a37.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/icons/pdf.svg
// module id = 620
// module chunks = 0